import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";

const PaymentCancelled = () => {
  const navigate = useNavigate();
  const { orgcode } = useParams();

  return (
    <Container
      fluid
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        maxWidth: "1600px",
        margin: "0 auto",
        paddingLeft: "20px",
        paddingRight: "20px",
      }}
    >
      <Row>
        <Col md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }}>
          <Card style={{
            borderRadius: "15px",
            boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
            border: "none"
          }}>
            <CardBody style={{ padding: "40px", textAlign: "center" }}>
              <div style={{
                width: "80px",
                height: "80px",
                backgroundColor: "#fff3cd",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px"
              }}>
                <i className="ri-close-circle-fill" style={{ fontSize: "48px", color: "#ffc107" }}></i>
              </div>

              <h2 style={{ 
                fontSize: "28px", 
                fontWeight: "bold", 
                marginBottom: "15px",
                color: "#333"
              }}>
                Payment Cancelled
              </h2>

              <p style={{ 
                fontSize: "16px", 
                color: "#666", 
                marginBottom: "30px",
                lineHeight: "1.6"
              }}>
                Your payment has been cancelled. No charges were made to your account. You can try again or choose a different payment method.
              </p>

              <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                <Button
                  style={{
                    flex: 1,
                    minWidth: "150px",
                    borderRadius: "10px",
                    fontWeight: "500",
                    backgroundColor: "#ffc107",
                    color: "#333",
                    border: "none"
                  }}
                  onClick={() => navigate(`/${orgcode}/customer-checkout`)}
                >
                  Try Again
                </Button>
                <Button
                  color="secondary"
                  style={{
                    flex: 1,
                    minWidth: "150px",
                    borderRadius: "10px",
                    fontWeight: "500",
                    backgroundColor: "lightgray",
                    color: "#333",
                    border: "none"
                  }}
                  onClick={() => navigate(`/${orgcode}`)}
                >
                  Back to Menu
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentCancelled;